// A MultiChoiceDropdownQuestion with no options renders nothing (see
// MultiChoiceDropdownQuestion.js) - the Card wrapping it (title,
// description, etc.) shouldn't be shown either in that case.
const hasRenderableControl = (question) => {
  if (question.QuestionType === "MultiChoiceDropdownQuestion") {
    return question.Options && question.Options.length > 0;
  }
  return true;
};

export default hasRenderableControl;
